import { State } from "../../types";

export type ToggleShowReadingOrderAction = Readonly<{
  type: "TOGGLE SHOW READING ORDER";
}>;

export const toggleShowReadingOrder = (
  state: State,
  _action: ToggleShowReadingOrderAction,
): State => {
  return {
    ...state,
    showReadingOrder: !state.showReadingOrder,
  };
};
